module.exports = __webpack_public_path__ + "assets/img/right-label-zh.c10f9f60.png";